module.exports = __webpack_public_path__ + "static/media/edit_segment_name_mobile.f3bbf36f.svg";